<template>
  <div class="register-form-con">
    <el-form
      class="section-form"
      ref="registerForm"
      v-model="registerForm"
    >
      <div
        v-show="step === 1"
        class="step-section"
      >
        <h2>立即注册</h2>

        <el-form-item
          style="margin-top:30px;"
          prop="telephone"
        >
          <el-input
            placeholder="请输入内容"
            class="phone-input-style"
            v-model="registerForm.telephone"
            :maxlength="countrySelect.area_code === 86 ? 11 : ''"
            @blur="inputNumBlur"
          >
            <template slot="prepend">
              <span class="pre-code">+86</span>
              <!-- <el-select
                :value="countrySelect.area_code"
                value-key="area_code"
                slot="prepend"
                placeholder="+86"
                class="country-select-con"
                @change="countrySelectAction"
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.id"
                  :label="item.area_code"
                  :value="item"
                >
                  <span>+{{ item.area_code }} {{ item.name_zh }} {{ item.english_name }}</span>
                </el-option>
              </el-select> -->
            </template>

          </el-input>
          <div class="hidden-input-country">
            <input id="phone" />
          </div>

        </el-form-item>

        <el-form-item prop="code">
          <el-input
            v-model.number="registerForm.code"
            class="append-input pass-input"
            placeholder="请输入短信验证码"
            maxlength="6"
            clearable
            @blur="sensorTrack('MSlogin_usercode')"
          >
            <el-button
              type="text"
              class="append-btn"
              slot="append"
              @click="sendMsgCode"
            >{{ sent ? `${countdown}s后重新获取` : '获取短信验证码' }}</el-button>
          </el-input>
        </el-form-item>
        <aliCaptcha ref="captcha" />

      </div>
    </el-form>

    <el-form
      ref="passForm"
      :model="passForm"
    >
      <div
        v-show="step === 2"
        class="step-section"
      >

        <h2>设置密码</h2>
        <el-form-item
          style="margin-top:30px;"
          prop="password"
          :rules="[
            { required: true, message: '请输入密码', trigger: 'blur' },
            {
              pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
              message: '请输入正确的密码，6-20字符包含字母和数字',
              trigger: 'blur'
            }
          ]"
        >
          <div class="password-input-style">
            <el-input
              class="pass-input-class"
              :type="passType"
              v-model="passForm.password"
              autocomplete="off"
              placeholder="请输入密码6-20位字符，包含字母和数字"
              clearable
              maxlength="20"
              minlength="6"
              @blur="sensorTrack('MSlogin_password')"
            >
            </el-input>
            <i
              class="append-icon"
              :class="[isClose ? 'icon_eye_close' : 'icon_eye_open']"
              @click="showPass"
            ></i>
          </div>

        </el-form-item>
      </div>
    </el-form>
    <el-form
      ref="moreForm"
      :model="moreForm"
      :rules="moreFormRules"
    >
      <div
        v-show="step === 3"
        class="step-section"
      >
        <h2>填写更多信息</h2>
        <p class="more-tips">您将成为新机构校长，并开启试用好课</p>
        <el-form-item v-if="hasSchool">
          <el-input
            v-if="schoolList.length === 1"
            v-model="moreForm.short_name"
            readonly
          ></el-input>
          <el-select
            v-else
            v-model="moreForm.id"
            placeholder="请选择试用机构"
            class="input-width"
            @change="schoolSelect"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :label="item.short_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="!hasSchool"
          prop="short_name"
        >
          <el-input
            v-model="moreForm.short_name"
            placeholder="请输入机构名称或您的姓名"
            maxlength="50"
            @blur="sensorTrack('MSlogin_Brand_name')"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="!hasSchool"
          prop="area_id"
        >
          <el-cascader
            v-model="areaSelect"
            :props="{label: 'name', value: 'id'}"
            :options="areaOption"
            class="input-width"
            placeholder="请选择所在省市区"
            @change="selectareaChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="business_category">
          <el-select
            v-model="moreForm.business_category"
            placeholder="请选择主营类目"
            class="input-width"
            @change="sensorTrack('MSlogin_category')"
          >
            <el-option
              v-for="item in categoryJson"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom:10px;">
          <el-input
            v-model="moreForm.referrer_name"
            placeholder="请填写推荐人姓名（选填）"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <div class="login-proxy">
          <el-checkbox
            v-model="moreForm.checkedProxy"
            @change="sensorTrack('MSlogin_agreement')"
          ><span class="checkbox-text">我已阅读并同意</span></el-checkbox>
          <a
            class="link-proxy"
            target="__blank"
            href="/proxy-haoke"
          >《魔法校用户认证注册协议》</a>
        </div>
      </div>
    </el-form>
    <div class="foot-group">
      <el-button
        type="primary"
        class="btn-next"
        :loading="btnLoading"
        :disabled="disableNextBtn"
        @click="toNext"
      >{{ step === 3 ? '立即使用' : '下一步' }}</el-button>
      <p class="login-tips">已有账号？<el-button
          type="text"
          class="login-btn"
          @click="toLogin"
        >立即登录</el-button>
      </p>
    </div>

  </div>
</template>

<script>
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'

import aliCaptcha from './aliCaptcha'
import { getAreaJson } from '@/services/interface'
import authApi from '@/services/auth'
import { categoryJson } from '@/const/registerConstant'

export default {
  components: {
    aliCaptcha
  },
  data () {
    return {
      categoryJson: categoryJson,
      isClose: true,
      passType: 'password',
      step: 1,
      registerForm: {
        telephone: '',
        code: ''
      },
      passForm: {
        password: ''
      },
      moreForm: {
        short_name: '',
        area_id: '',
        id: '',
        business_category: '',
        checkedProxy: false,
        referrer_name: ''
      },
      moreFormRules: {
        short_name: [
          { required: true, message: '请输入机构名称或您的姓名', trigger: 'blur' }
        ],
        area_id: [
          { required: true, message: '请选择所在省市区', trigger: 'change' }
        ],
        id: [
          { required: true, message: '请选择试用机构', trigger: 'change' }
        ],
        business_category: [
          { required: true, message: '请选择主营类目', trigger: 'change' }
        ]
      },
      countdown: 60,
      sent: false,
      areaOption: [],
      areaSelect: [],
      btnLoading: false,
      hasSchool: false,
      schoolList: [],
      schoolName: '',
      countryList: [],
      countrySelect: {
        area_code: 86,
        cooperation_status: 1,
        country_code: 86,
        created_at: "2021-03-08 17:25:58",
        deleted_at: null,
        english_name: "China",
        id: 44,
        is_active: 1,
        iso: "CN",
        iso3: "CHN",
        name: "CHINA",
        name_zh: "中国大陆",
        numcode: 156,
        opt_status: 1,
        updated_at: "2021-03-08 17:25:58"
      },
      tempToken: ''
    }
  },
  computed: {
    disableNextBtn () {
      if (this.step === 1) {
        return !this.registerForm.telephone || !this.registerForm.code
      } else if (this.step === 3) {
        return !this.moreForm.short_name || !this.moreForm.area_id || !this.moreForm.business_category || (this.hasSchool && !this.moreForm.id)
      }
      return false
    }
  },
  created () {
    this.getArea()
    this.getCountryCode()
  },
  mounted () {
    this.initialTelInput()
  },
  methods: {
    schoolSelect (schoolId) {
      const element = this.schoolList.find(item => {
        return item.id === schoolId
      })
      if (element) {
        this.moreForm.area_id = element.area_id
        this.moreForm.short_name = element.short_name
        this.moreForm.referrer_name = element.referrer_name
        // this.moreForm.business_category = element.business_category
      }
    },
    getCountryCode () {
      authApi.getCountryCode().then(res => {
        if (res.ok) {
          this.countryList = res.data
          const item = this.countryList.find(item => {
            return item.iso === 'CN'
          })
          this.countrySelect = item
        }
      })
    },
    countrySelectAction (val) {
      console.log(val, 877)
      this.countrySelect = val
    },
    initialTelInput () {
      this.phoneInput = intlTelInput(document.querySelector('#phone'), {
        nationalMode: false,
        separateDialCode: true,
        initialCountry: 'cn',
        preferredCountries: ['cn'],
        utilsScript: require('intl-tel-input/build/js/utils.js')
      })
    },
    toNext () {
      if (this.step === 1) {
        this.sensorTrack('MSlogin_nextone')
        if (!this.validatePhone() || !this.validateCode()) {
          return
        }
        this.getSchoolRegisterStatus()
      } else if (this.step === 2) {
        this.sensorTrack('MSlogin_nexttwo')
        this.$refs.passForm.validate((valid) => {
          if (valid) {
            this.step++
          }
        })
      } else if (this.step === 3) {
        this.sensorTrack('MSlogin_submit')
        this.validateStep3()
      }
    },
    validateStep3 () {
      this.$refs.moreForm.validate((valid) => {
        if (valid) {
          if (!this.moreForm.checkedProxy) {
            this.$confirm('请先勾选协议<a class="link-proxy" target="__blank" href="/proxy-haoke">《魔法校用户认证注册协议》</a>', '', {
              confirmButtonText: '同意',
              cancelButtonText: '取消',
              center: true,
              dangerouslyUseHTMLString: true
            }).then(() => {
              this.moreForm.checkedProxy = true
              this.toRegisterAction()
            }).catch(() => {
            })
          } else {
            this.toRegisterAction()
          }
        }
      })
    },
    validatePhone () {
      this.phoneInput.setNumber(`+${this.countrySelect.area_code}${this.registerForm.telephone}`)
      // const phone = this.phoneInput.getNumber()
      const valid = this.phoneInput.isValidNumber()
      const { iso2, dialCode } = this.phoneInput.getSelectedCountryData()
      console.log(phone, valid, iso2, dialCode, this.registerForm.telephone)
      if (!valid) {
        this.$message.error('请输入正确的手机号')
        return false
      }
      return true
    },
    validateCode () {
      if (!this.registerForm.code) {
        this.$message.error('请输入验证码')
        return false
      }
      return true
    },
    sendMsgCode () {
      if (this.sent || !this.validatePhone()) {
        return
      }

      const params = {
        telephone: this.registerForm.telephone,
        type: 6
      }

      this.sensorTrack('MSlogin_message_code')

      this.handleCaptcha(params)
      this.startCountdown()
    },
    handleCaptcha (params) {
      this.$refs.captcha.handleCaptcha(params)
    },
    startCountdown () {
      this.countdown = 60
      this.sent = true
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.sent = false
          clearInterval(this.intervalId)
        }
      }, 1000)
    },
    getSchoolRegisterStatus () {
      const params = {
        telephone: this.registerForm.telephone,
        code: this.registerForm.code
      }
      this.btnLoading = true
      authApi.getRegisterStatus(params).then(res => {
        console.log(res)
        this.btnLoading = false
        if (res.ok) {
          const data = res.data
          this.tempToken = data.token
          this.handleRegisterStatus(data)
        }
      })
    },
    handleRegisterStatus (data) {
      if (data.ms_school_count > 0) {
        // 有魔法校机构 是校长
        this.$confirm('当前手机号已注册，请直接登录', '', {
          distinguishCancelAndClose: true,
          confirmButtonText: '去登录',
          cancelButtonText: '更换手机号',
          center: true
        }).then(() => {
          window.location.href = `${process.env.VUE_APP_LOGIN_URL + '/auth/login'}`
        }).catch((action) => {
          if (action === 'cancel') {
            this.registerForm.telephone = ''
            this.registerForm.code = ''
          }
        })
      } else if (data.has_auth) {
        // 已认证 直接去填写信息
        this.step = 3
        if (data.school_count > 0) {
          this.hasSchool = true
          this.getRegisterSchoolList()
        }
      } else {
        if (data.school_count > 0) {
          this.hasSchool = true
          this.getRegisterSchoolList()
        }
        // 未认证 填写密码
        this.step = 2
      }
    },
    getRegisterSchoolList () {
      const params = {
        token: this.tempToken
      }
      authApi.getRegisterSchools(params).then(res => {
        if (res.ok) {
          this.schoolList = res.data
          if (this.schoolList.length === 1) {
            // this.schoolName = this.schoolList[0].short_name
            this.moreForm.id = this.schoolList[0].id
            this.moreForm.area_id = this.schoolList[0].area_id
            // this.moreForm.business_category = this.schoolList[0].business_category
            this.moreForm.short_name = this.schoolList[0].short_name
            this.moreForm.referrer_name = this.schoolList[0].referrer_name
          }
        }
      })
    },
    toRegisterAction () {
      const params = {
        source: 5, // 好课
        token: this.tempToken,
        business_category: this.moreForm.business_category,
        user_country_id: this.countrySelect.id,
        short_name: this.moreForm.short_name,
        school_id: this.moreForm.id,
        area_id: this.moreForm.area_id,
        referrer_name: this.moreForm.referrer_name
      }

      if (this.passForm.password) {
        params.password = this.passForm.password
      }

      console.log(params, 'register recommend')

      this.btnLoading = true
      authApi.registerSchool(params).then(res => {
        this.btnLoading = false
        if (res.ok) {
          const data = res.data
          window.location.href = `${process.env.VUE_APP_LOGIN_URL}/mall?officialFrom=website&officialToken=${data.token}&officialUserId=${data.user_id}`
        }
      })
    },
    showPass () {
      this.isClose = !this.isClose
      this.passType = this.isClose ? 'password' : 'text'
    },
    getArea () {
      getAreaJson().then(res => {
        this.areaOption = res.data
      })
    },
    selectareaChange (val) {
      console.log(val)
      this.moreForm.area_id = val[val.length - 1]
      this.sensorTrack('MSlogin_address')
    },
    toLogin () {
      this.sensorTrack('MSlogin_login')
      window.open(`${process.env.VUE_APP_LOGIN_URL + '/auth/login'}`)
    },
    inputNumBlur () {
      this.sensorTrack('MSlogin_phone_num')
    },
    sensorTrack (eventName, params) {
      try {
        window.sensors.track(eventName, params)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.register-form-con {
  height: 100%;
  position: relative;
  width: 328px;
  .step-section {
    text-align: left;
    h2 {
      font-size: 26px;
      font-weight: 500;
    }
  }
  .section-form {
    // margin-top: 20px;
  }

  .input-width {
    width: 328px;
  }

  .foot-group {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
  }

  .btn-next {
    width: 100%;
    color: #fff;
    // background: rgba(1, 129, 255, 1);
  }

  .login-tips {
    // margin-top: 20px;
    font-size: 12px;
    color: #666666;
    .login-btn {
      color: #0181ff;
    }
  }

  .append-btn {
    background-color: #fff;
    color: #0181ff;
    padding-right: 8px;
    padding-left: 8px;
  }

  .login-proxy {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 17px;
    padding-left: 10px;
  }

  .checkbox-text {
    font-size: 12px;
  }

  .link-proxy {
    color: #0181ff;
    font-size: 12px;
  }

  .append-icon {
    position: absolute;
    right: 8px;
    top: 13px;
    background-color: #fff;
    padding-right: 10px;
    cursor: pointer;
  }

  .icon_eye_close {
    display: inline-block;
    width: 20px;
    height: 10px;
    margin-top: 3px;
    background-size: 100%;
    background: url(//fe-cdn.mofaxiao.com/cactus-web/img/eye_close.png)
      no-repeat;
    background-size: 20px 10px;
    vertical-align: middle;
  }
  .icon_eye_open {
    display: inline-block;
    width: 22px;
    height: 16px;
    background-size: 100%;
    background: url(//fe-cdn.mofaxiao.com/cactus-web/img/eye_open.png) no-repeat;
    background-size: 22px 16px;
    vertical-align: middle;
  }
}
.more-tips {
  font-size: 12px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 17px;
  margin-top: 2px;
  margin-bottom: 10px;
}

.pre-code {
  padding-right: 6px;
  display: inline-block;
  vertical-align: middle;
}
.country-select-con {
  width: 70px;
  text-align: center;
}
</style>

<style lang="scss">
.append-input {
  .el-input__inner {
    border-right: 0;
  }
}

.pass-input {
  .el-input__inner:focus {
    border-color: #dcdfe6;
  }
}
.phone-input-style {
  .el-input__inner {
    border-left: none;
  }
  .el-input__inner:focus {
    border-color: #dcdfe6;
  }
  .el-input-group__prepend {
    background: transparent;
    border-right: none;
    position: relative;
  }
  .el-input-group__prepend::after {
    position: absolute;
    content: "";
    right: 0;
    top: 4px;
    height: 30px;
    width: 1px;
    background: #dcdfe6;
  }
  .iti--allow-dropdown {
    width: 100%;
  }

  .iti--separate-dial-code .iti__selected-flag {
    background-color: #fff;
  }
  .iti__selected-flag:focus {
    border: none;
    outline: none;
  }

  .iti__country-list {
    width: 328px;
  }
}
.hidden-input-country {
  display: none;
}
.password-input-style {
  position: relative;
  .pass-input-class {
    .el-input__suffix {
      right: 30px;
    }
  }
}
</style>
